import React, {Component} from 'react';

import {SkyLightStateless} from 'react-skylight';

import {Spinner} from "../../../../../components/Loading/Spinner";

export default class DischargeExitControl extends Component {

    constructor(props) {
        super(props);

        this.state = {
            trip: props.trip,
            movements_observations: '',
            showModal: true,
            ajaxInProgress: false
        }
    }

    _closeModal = () => {
        this.setState({showModal: false});

        if(this.props.afterCloseAction){
            this.props.afterCloseAction();
        }
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _submitForm = () => {
        if(!this.state.movements_observations || this.state.movements_observations === ''){
            return false;
        }

        this.setState({ajaxInProgress: true});

        this.props.updateAction(this.state.movements_observations);
    };

    render() {

        let {trip} = this.state;

        let modalStyle = {
            boxShadow: 'none',
            top: '30%'
        };

        let buttonsDisabled = this.state.ajaxInProgress;

        let unit = '(Lts.)';
        let difference = `${trip.provider_load_volume} / ${trip.unload_weight}`;

        if(trip.product.code.toLowerCase() === 'fame'){
            unit = '(Kgs.)';
            difference = `${trip.unload_volume} / ${trip.unload_weight}`;
        }

        return (
            <div>
                <SkyLightStateless
                    onOverlayClicked={this._closeModal}
                    isVisible={this.state.showModal}
                    onCloseClicked={this._closeModal}
                    dialogStyles={modalStyle}
                    title={<h3 className="center" style={{fontSize: '30px'}}>Enviar a Balanza</h3>}
                >
                    <div className={"row margin-top-20 text-left"}>
                        <div className={"col s12 center"}>
                            <p>La cantidad descargada no coincide con la despachada.</p>
                            <p>¿Enviar a balanza de todos modos?</p>
                        </div>
                    </div>
                    <div className={"row thin-row"}>
                        <div className={"col s8 input-field input-grey"}>
                            <label className="active">Cantidad Descargada {unit}</label>
                            <p className={"field-p shell-red-text"}>
                                {difference}
                                <i className="material-icons shell-red-text control-exit-i">error</i>
                            </p>
                        </div>
                        <div className={"col s4 input-field input-grey"}>
                            <label className="active">Cantidad de cisternas</label>
                            <p className={"field-p"}>{trip.compartments}</p>
                        </div>
                        <div className={'col s12 control-exit-error'}>
                            Corrobore que se han descargado todas las cisternas
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={`col s12 input-field ${this.state.warn_observation ? 'error-input' : ''}`}>
                            <label className="active">Observaciones</label>
                            <textarea
                                className={"materialize-textarea dispatch-textarea"} rows={4}
                                onChange={(ev) => this._handleInput('movements_observations', ev.target.value)}
                                defaultValue={this.state.movements_observations}
                            />
                            {this.state.warn_observation &&
                            <div className={'shell-red-text'}>* Ingrese observaciones</div>
                            }
                        </div>
                        <div className={"col s12 center margin-top-30"}>
                            <button className={`btn btn-shell-empty z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`}
                                    onClick={this._closeModal}>
                                Cancelar
                            </button>
                            <button className={`btn btn-shell z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`} onClick={this._submitForm}>
                                Enviar a Balanza
                            </button>
                        </div>
                    </div>
                    {this.state.ajaxInProgress ? <Spinner /> : <div><br/><br/></div>}
                </SkyLightStateless>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargeExitControl.js